import styled from 'styled-components';
import { palette } from '@dev/ee-components';

export const SelectCampaignWrapper = styled.div`
    background: #fff;
    border: 1px solid ${palette.gray[3]};
    margin-right: 30px;
    max-height: 440px;
`;

export const CampaignSelectDescribe = styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px;
    border-top: 1px solid ${palette.gray[3]};
    align-items: center;
`;
